export default __webpack_public_path__ + "static/media/user_expanded.96494229.jpg";